// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
}

/* Variants */
.button.primary {
  background-color: #DA7027;
  color: #FFFDFC;
}

.button.primary:hover {
  background-color: #B24C26;
  color: #FFFDFC;
}

.button.third {
  background-color: #FFFDFC;
  color: #595959;
  border: 1px solid #595959;
}

.button.third:hover {
  background-color: #595959;
  color: #FFFDFC;
  border: 1px solid #595959;
}

.button.secondary:hover .button-icon svg,
.button.secondary:hover .button-icon svg path {
  fill: #595959 !important;
  stroke: #595959 !important;
}

.button.secondary .button-icon svg,
.button.secondary .button-icon svg path {
  fill: #FFFDFC !important;
  stroke: #FFFDFC !important;
}

.button.third:hover .button-icon svg,
.button.third:hover .button-icon svg path {
  fill: #FFFDFC !important;
  stroke: #FFFDFC !important;
}

.button.secondary {
  background-color: #595959;
  color: #FFFDFC;
  border: 1px solid #595959;
}

.button.secondary:hover {
  background-color: #FFFDFC;
  color: #595959;
  border: 1px solid #595959;
}

/* Sizes */
.button.small {
  padding: 1rem;
  font-size: 1.3rem;
  max-height: 50px;
}

.button.medium {
  padding: 1.5rem;
  font-size: 1.6rem;
}

.button.large {
  padding: 2rem;
  font-size: 2rem;
}

/* Disabled state */
.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-icon svg {
  width: 20px;
  height: 20px;
}

.button.primary, .button.secondary, .button.thrid {
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/composants/Button/Button.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":[".button {\r\n  border: none;\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  transition: all 0.2s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Variants */\r\n.button.primary {\r\n  background-color: #DA7027;\r\n  color: #FFFDFC;\r\n}\r\n\r\n.button.primary:hover {\r\n  background-color: #B24C26;\r\n  color: #FFFDFC;\r\n}\r\n\r\n.button.third {\r\n  background-color: #FFFDFC;\r\n  color: #595959;\r\n  border: 1px solid #595959;\r\n}\r\n\r\n.button.third:hover {\r\n  background-color: #595959;\r\n  color: #FFFDFC;\r\n  border: 1px solid #595959;\r\n}\r\n\r\n.button.secondary:hover .button-icon svg,\r\n.button.secondary:hover .button-icon svg path {\r\n  fill: #595959 !important;\r\n  stroke: #595959 !important;\r\n}\r\n\r\n.button.secondary .button-icon svg,\r\n.button.secondary .button-icon svg path {\r\n  fill: #FFFDFC !important;\r\n  stroke: #FFFDFC !important;\r\n}\r\n\r\n.button.third:hover .button-icon svg,\r\n.button.third:hover .button-icon svg path {\r\n  fill: #FFFDFC !important;\r\n  stroke: #FFFDFC !important;\r\n}\r\n\r\n.button.secondary {\r\n  background-color: #595959;\r\n  color: #FFFDFC;\r\n  border: 1px solid #595959;\r\n}\r\n\r\n.button.secondary:hover {\r\n  background-color: #FFFDFC;\r\n  color: #595959;\r\n  border: 1px solid #595959;\r\n}\r\n\r\n/* Sizes */\r\n.button.small {\r\n  padding: 1rem;\r\n  font-size: 1.3rem;\r\n  max-height: 50px;\r\n}\r\n\r\n.button.medium {\r\n  padding: 1.5rem;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.button.large {\r\n  padding: 2rem;\r\n  font-size: 2rem;\r\n}\r\n\r\n/* Disabled state */\r\n.button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.button-icon svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.button.primary, .button.secondary, .button.thrid {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
